import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const FileStatusIconPreparing = memo(() => {
  return (
    <div aria-hidden className="mr-3 flex size-10 items-center justify-center rounded-full bg-grey-4">
      <Spinner className="size-6" color="grey" />
    </div>
  );
});

FileStatusIconPreparing.displayName = 'FileStatusIconPreparing';
